import { registerComponent } from '@gig/magic-common';
import SweepstakesVerificationComponent from './sweepstakes-verification.vue.js';

var SweepstakesVerification = registerComponent(SweepstakesVerificationComponent);

export { SweepstakesVerification };
